"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.batchedUpdates = exports.version = void 0;
var react_1 = __importDefault(require("react"));
var react_dom_1 = __importDefault(require("react-dom"));
var ver = react_1.default.version.split('.').map(parseFloat);
function version() {
  return ver;
}
exports.version = version;
function batchedUpdates(cb) {
  react_dom_1.default.unstable_batchedUpdates(cb);
}
exports.batchedUpdates = batchedUpdates;